/* eslint-disable jsx-a11y/alt-text */
import {
	Deck,
	Slide,
	Heading,
	CodePane,
	FlexBox,
	Grid,
	Text,
	Link,
	UnorderedList,
	ListItem,
	OrderedList,
	Image
} from "spectacle";
import cb from "react-syntax-highlighter/dist/cjs/styles/prism/cb";

import remixlogo from "./svg/remix.svg";
import sanitylogo from "./svg/sanity.svg";
import teamliquidlogo from "./svg/teamliquid.svg";

const theme = {
	colors: {
		primary: "#dcdcdc",
		text: "#DcDcDc",
		secondary: "#f37368",
		bgc: "#212121",
		link: "#0f0"
	},
	fontSizes: {
		header: "64px",
		paragraph: "28px",
		list: "30px"
	}
};

const App = () => (
	<Deck theme={theme}>
		<Slide backgroundColor="bgc">
			<Grid gridTemplateRows="1fr auto 1fr ">
				<Heading color="primary">Aplicaciones ricas en contenido con</Heading>
				<FlexBox justifyContent="center">
					<img src={remixlogo} width="300" />
					<h2 style={{ marginRight: "30px", fontSize: "40px" }}>+</h2>
					<img src={sanitylogo} width="200" />
				</FlexBox>
				<FlexBox justifyContent="center" alignItems="flex-end">
					<h2>@jossdz</h2>
				</FlexBox>
			</Grid>
		</Slide>

		<Slide backgroundColor="bgc">
			<Grid gridTemplateRows="0.8fr 2fr auto">
				<Heading>Sobre mi</Heading>

				<FlexBox justifyContent="center">
					<img
						src="https://cdn-images-1.medium.com/max/1200/1*69RcxrWXuk385lSxkIYYLA.png"
						width="150"
					/>
					<img src={teamliquidlogo} width="120" />
				</FlexBox>
				<FlexBox justifyContent="center">
					<ul>
						<li>Ing. en sistemas computacionales</li>
						<li>Comunidades en tech</li>
					</ul>
				</FlexBox>
			</Grid>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Comencemos con Sanity</Heading>

			<Text>
				<Link target="_blank" href="sanity.io">
					Sanity
				</Link>{" "}
				es un headless CMS, open source que te otorga una plataforma para el
				contenido estructurado de tu app, esta plataforma es llamada Sanity
				studio que te da el poder de editar tu contenido en tiempo real.
			</Text>
		</Slide>

		<Slide backgroundColor="bgc">
			<img src="https://i.postimg.cc/fRRGDZQL/Screen-Shot-2022-04-07-at-7-16-34-p-m.png" />
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Ventajas de utilizar Sanity</Heading>
			<UnorderedList fontSize="list">
				<ListItem>
					Habilita edicion del contenido en tu app para todos.
				</ListItem>
				<ListItem>
					Acceso a la informacion de tu Sanity Studio desde cualquier lado.
				</ListItem>
				<ListItem>
					Tiene un sistema de plugins que se ajusta a las necesitades de tu
					contenido.
				</ListItem>
				<ListItem>
					Tienen un enfoque increible en DX(Developer Experience -> Experiencia
					de desarrollo).
				</ListItem>
				<ListItem>
					Configurar y comenzar a disfrutar de tu contenido es muy rapido.
				</ListItem>
				<ListItem>
					<Link
						fontSize="list"
						href="https://www.sanity.io/boostedplan"
						target="_blank"
					>
						Comenzar es gratis *.
					</Link>
				</ListItem>
			</UnorderedList>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Pasos:</Heading>

			<OrderedList fontSize="list">
				<ListItem>
					<pre>npm i -g @sanity/cli</pre>
				</ListItem>
				<ListItem>
					<pre>sanity login</pre>
				</ListItem>
				<ListItem>
					<pre>sanity init --coupon meetup</pre>
				</ListItem>
				<ListItem>
					<pre>Crear los esquemas de nuestro contenido</pre>
				</ListItem>
			</OrderedList>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Esquemas</Heading>

			<Text>
				Esquemas son una forma de organizar nuestro contenido y existen
				diferentes{" "}
				<Link href="https://www.sanity.io/docs/schema-types" target="_blank">
					tipos de datos
				</Link>{" "}
				dentro de los esquemas que nos van a ayudar a darle forma a nuestro
				contenido.
			</Text>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Estructura de un esquema</Heading>
			<CodePane language="javascript" theme={cb}>
				{`
          
            // Debemos devolver un objeto con cierta informacion que Sanity studio necesita
             export default {
              name: 'user', // Nombre con el que sanity va a identificar recursos de este tipo
              type: 'document', // Ya que este es un esquema su tipo es document
              title: 'User', // Este es el titulo que aparecera en el editor de Sanity Studio
              fields: [ // Aqui vamos a listar los campos que tendra nuestro esquema
                {
                  name: 'username',
                  type: 'string',
                  title: 'Username'
                }
              ]
             
            `}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Agregar el esquema al studio</Heading>
			<CodePane
				language="javascript"
				theme={cb}
				highlightRanges={[
					[1, 1],
					[5, 8]
				]}
			>
				{`
            import user from "./user";

            export default createSchema({
              name: "default",
              types: schemaTypes.concat([
                /* Your types here! */
                user
              ])               
            `}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>
				Esquemas listos? <br />
				desplguemos el cms
			</Heading>

			<CodePane language="bash" theme={cb}>
				{`
					sanity deploy
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Text>
				Una vez listo el cms desplegado, nos entrega la url que podemos
				compartir con la gente encargada de gestionar el contenido.
			</Text>
			<FlexBox justifyContent="center">
				<Image
					width="500"
					src="https://i.postimg.cc/HWhjwCXy/Screen-Shot-2022-04-18-at-6-03-36-p-m.png"
					alt="deployed_cms"
				/>
			</FlexBox>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Ahora un poco de</Heading>
			<FlexBox justifyContent="center">
				<img src={remixlogo} width="800" />
			</FlexBox>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Inicialicemos un nuevo proyecto de Remix</Heading>
			<CodePane language="bash" theme={cb}>
				{`
					npx create-remix
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Rapida intro a remix</Heading>
			<Text>
				Cada archivo en <em>app/routes</em> sera una vista y lucen de la
				siguiente manera:
			</Text>
			<CodePane language="jsx" theme={cb}>
				{`
					export const loader = () => {
						return {}
					}

					export const action = () => {
						return {}
					}

					export default () => {
						return (
						<div>
							<h1>Hello world!</h1>
						</div>
					)}
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Renderizar contenido</Heading>

			<CodePane language="jsx" theme={cb}>
				{`
					export default () => {
						return (
						<div>
							<h1>Hello world!</h1>
						</div>
					)}
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Cargar contenido en la vista</Heading>

			<CodePane language="jsx" theme={cb}>
				{`
					import { useLoaderData } from "@remix-run/react";

					export const loader = () => {
						return {
							msg: "Hello world!"
						};
					};
					
					export default () => {
						const { msg } = useLoaderData();
						return (
							<div>
								<h1>{msg}</h1>
							</div>
						);
					};					
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Enviar info al servidor</Heading>

			<CodePane language="jsx" theme={cb}>
				{`
					import { Form } from "@remix-run/react";

					export const action = async ({ request }) => {
						const formData = await request.formData();
						const msg = formData.get("msg");
						console.log("DATA", msg);
						return {};
					};
					
					export default () => {
						return (
							<div>
								<Form method="post">
									<input type="text" name="msg" />
									<button type="submit">enviar</button>
								</Form>
							</div>
						);
					};
												
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<FlexBox
				alignContent="center"
				justifyContent="center"
				style={{ height: "100%" }}
			>
				<Text>
					Ahora que sabemos lo basico indispensable de Remix, conectemos con
					Sanity usando el{" "}
					<Link href="https://www.npmjs.com/package/@sanity/client">
						cliente de Sanity.
					</Link>
				</Text>
			</FlexBox>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>Sanity Client config</Heading>

			<CodePane language="jsx" theme={cb}>
				{`
					// app/utils/sanityClient.js
					
					import sanityClient from "@sanity/client";
					import imageUrlBuilder from "@sanity/image-url";
					const client = sanityClient({
						projectId: 'your-project-id',
						dataset: 'bikeshop',
						apiVersion: '2022-04-19',
						token: 'sanity-auth-token',
						useCdn: false, 
					})

					const builder = imageUrlBuilder(client);

					export const urlFor = (source) => builder.image(source);

					export default client;

				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Text>
				La informacion del proyecto requerida para conectar con el frontend la
				encuentras con el comando:
			</Text>
			<CodePane language="bash" theme={cb}>
				{`
					sanity manage
				`}
			</CodePane>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>GROQ para queries</Heading>
			<Text>
				Sanity utiliza su propio sistema de query para pedir informacion. y aun
				que no es muy complejo, aqui tienes una{" "}
				<Link
					href="https://www.sanity.io/docs/query-cheat-sheet"
					target="_blank"
				>
					cheat-sheet
				</Link>{" "}
				que te da muchos ejemplos.
			</Text>
		</Slide>

		<Slide backgroundColor="bgc">
			<Heading>CRUD</Heading>
			<Text>
				Tambien dejo para ti la documentacion de{" "}
				<Link
					href="https://www.sanity.io/docs/query-cheat-sheet"
					target="_blank"
				>
					Sanity client
				</Link>{" "}
				que tiene documentadas todas las operaciones posibles, desde creacion de
				nuevos recursos hasta edicion y manejo de referencias.
			</Text>
		</Slide>
	</Deck>
);

export default App;
